<template>
  <div>
    <menu-item
      :item="tab"
      :key="tab.id"
      v-for="tab in tabs"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import MenuItem from '@/components/menu/MenuItem';
import MenuItemMixin from '@/mixins/MenuItemMixin';

export default {
  name: 'SaasMenu',

  mixins: [
    MenuItemMixin,
  ],

  components: {
    MenuItem,
  },

  computed: {
    ...mapGetters('saas', {
      pendingAccessRequests: 'GET_PENDING_ACCESS_REQUESTS',
      pendingServicesRequests: 'GET_PENDING_SERVICES_REQUESTS',
    }),
    ...mapGetters('subscription', {
      saasSubscription: 'GET_SAAS_SUBSCRIPTION',
    }),
    ...mapGetters('user', {
      readOnly: 'GET_READONLY_INFO',
    }),

    canShowSaasItems() {
      return this.hasSaasSubscription
          && this.readOnly?.ownerSaasId
          || this.readOnly?.saasRole
          && this.readOnly?.saasRole !== 'user';
    },

    hasSaasSubscription() {
      return !!this.saasSubscription;
    },

    isSaas() {
      return !!this.readOnly?.saasId;
    },

    isSaasOwner() {
      return this.readOnly?.ownerSaasId || this.readOnly?.saasRole === 'owner';
    },

    isSaasSubscriptionActive() {
      return this.saasSubscription && this.saasSubscription.status !== 'inactive';
    },

    isSaasMarketplaceEnabled() {
      return this.readOnly?.isDoctorMarketplaceEnabled || false;
    },

    tabs() {
      const hasPendingAccessRequests = this.pendingAccessRequests > 0;
      const hasPendingServicesRequests = this.pendingServicesRequests > 0;
      const tabs = [];

      tabs.push(
        {
          active: this.isActive('owner-saas-dashboard'),
          color: 'blue',
          icon: 'mdi-view-dashboard-variant',
          title: this.$t('menu.dashboard'),
          to: 'owner-saas-dashboard',
        },
        {
          active: this.isActive('owner-saas-subscription'),
          color: 'blue',
          icon: 'mdi-file-document',
          title: this.isSaasOwner ? 'Configuração' : 'Assinatura',
          to: 'owner-saas-subscription',
        },
        ...(
          this.isSaasSubscriptionActive
            ? [
                {
                  color: 'green',
                  icon: 'mdi-cog-outline',
                  title: this.$t('menu.myHabitat'),
                  submenus: [
                    { 
                      active: this.isActive('owner-saas-team'),
                      color: 'green',
                      title: this.$t('menu.team'),
                      to: 'owner-saas-team',
                    },
                    {
                      active: this.isActive('owner-saas-users'),
                      alert: hasPendingAccessRequests,
                      badge: () => {
                        return this.pendingAccessRequests;
                      },
                      color: 'green',
                      title: this.$t('menu.saasUsers'),
                      to: 'owner-saas-users',
                    },
                  ],
                },
                {
                  color: 'orange',
                  disabled: !this.isSaasSubscriptionActive,
                  icon: 'mdi-domain',
                  title: this.$t('menu.myProperties'),
                  submenus: [
                    {
                      active: this.isActive('owner-saas-unities', 'owner-saas-spaces'),
                      title: this.$t('menu.myUnities'),
                      to: 'owner-saas-unities-list',
                      color: 'orange',
                    },
                    {
                      active: this.isActive('owner-saas-calendar'),
                      disabled: !this.isSaasSubscriptionActive,
                      title: this.$t('menu.calendar.saas.events'),
                      to: 'owner-saas-calendar',
                      color: 'orange',
                    },
                    {
                      active: this.isActive('owner-saas-events'),
                      disabled: !this.isSaasSubscriptionActive,
                      title: this.$t('menu.historyEvents'),
                      to: 'owner-saas-events',
                      color: 'orange',
                    },
                    {
                      active: this.isActive('owner-saas-services'),
                      alert: hasPendingServicesRequests,
                      badge: () => {
                        return this.pendingServicesRequests;
                      },
                      color: 'orange',
                      disabled: !this.isSaasSubscriptionActive,
                      title: this.$t('menu.services'),
                      to: 'owner-saas-services',
                    },
                  ]
                },
                {
                  active: this.isActive('owner-saas-slots'),
                  disabled: !this.isSaasSubscriptionActive,
                  icon: 'mdi-calendar-month',
                  color: 'purple',
                  title: this.$t('menu.calendar.saas.slots'),
                  to: 'owner-saas-slots',
                },                
                {
                  active: this.isActive('owner-saas-marketplace'),
                  color: 'blue',
                  icon: 'mdi-shopping',
                  soon: true,
                  title: this.$t('menu.marketplace'),
                  to: 'owner-saas-marketplace',
                  disabled: !this.isSaasMarketplaceEnabled,
                },
              ]
            : []
        ),
      );

      return tabs
        .filter(Boolean);
    },
  },
}
</script>
